import { Button } from '@material-ui/core';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SearchIcon from '@mui/icons-material/Search';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import Banner from '../../atoms/Banner/Banner';
import Typography from '../../atoms/Typography/Typography';
import ContentBox from '../../molecules/ContentBox';
import PagiNation from '../../molecules/PagiNation/PagiNation';
import SearchInput from '../../molecules/SearchInput/SearchInput';
import brochureData from '../../../data/brochure.json';
const useStyles = makeStyles({
  root: {},
  brochureBox: {
    display: 'flex',
    justifyContent: 'center',

    '@media only screen and (max-width: 768px)': {
      marginTop: '0px',
    },
  },
  gridBox: {
    display: 'flex',
    justifyContent: 'center',
  },
  dataBox: {
    width: '90%',
    height: '300px',
    marginBottom: '140px',
    display: 'flex',
    justifyContent: 'space-between',

    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column-reverse',
      justifyContent: 'center',
      height: 'fit-content',
      minHeight: '520px',

      // '&:hover': {
      //   '&>div': {
      //     '&>img': {
      //       marginLeft: '0px',
      //       marginTop: '0px',
      //     },
      //   },
      // },
    },
  },
  dataLeft: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',

    '@media only screen and (max-width: 768px)': {
      // marginLeft: '10%',
    },
  },
  no: {
    color: '#313E94',
    fontSize: '16px',
    marginBottom: ' 40px',
    '@media only screen and (max-width: 768px)': {
      marginBottom: ' 5px',
    },
  },
  title: {
    fontSize: '24px',
    marginBottom: ' 12px',
    '@media only screen and (max-width: 768px)': {
      marginBottom: ' 5px',
    },
  },
  date: {
    fontSize: '18px',
    marginBottom: '20px',
  },
  btnBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',

    '@media only screen and (max-width: 768px)': {
      width: '100%',
      marginBottom: '-32px',
    },
  },
  downBtn: {
    borderRadius: '50%',
    border: 'solid 1px',
    width: '100px',
    height: '100px',
    color: '#0A51A3',
    borderColor: '#0A51A380',
    fontWeight: 'bold',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#0A51A3',
      color: '#fff',
    },
    '@media only screen and (max-width: 768px)': {
      width: '48%',
      height: '60px',
      borderRadius: '0%',
    },
  },
  downBtnBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  viewBtn: {
    borderRadius: '50%',
    border: 'solid 1px',
    width: '100px',
    height: '100px',
    borderColor: '#00000030',
    marginLeft: '20px',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#00000010',
      color: '#black',
    },
    '@media only screen and (max-width: 768px)': {
      height: '60px',
      width: '48%',
      borderRadius: '0%',
    },
  },
  viewBtnBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  btnText: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
  dataRight: {
    width: '50%',

    '@media only screen and (max-width: 768px)': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  img: {
    position: 'absolute',
    width: '300px',
    boxShadow: '8px 8px 8px #00000030',
    '@media only screen and (max-width: 768px)': {
      width: '100%',
      minWidth: '300px',
      position: 'static',
      // marginLeft: '10%',
    },
  },
  imgBack: {
    backgroundColor: '#00000030',
    width: '300px',
    zIndex: -1,
    marginLeft: '10px',
    marginTop: '10px',
    '@media only screen and (max-width: 768px)': {
      width: '50%',
    },
  },
  searchArea: {
    display: 'flex',
    marginBottom: '16px',
    zIndex: 1,
    '@media only screen and (max-width: 768px)': {
      marginBottom: '16px',
    },
    justifyContent: 'flex-end',
  },
  input: {
    width: '240px',
    borderBottom: '1px solid',
    minWidth: '120px',
    marginLeft: '-20px',
    '@media only screen and (max-width: 768px)': {
      width: '160px',
    },
  },
  searchIcon: {
    position: 'absolute',
    marginLeft: '195px',
    '@media only screen and (max-width: 768px)': {
      marginLeft: '100px',
    },
  },
  paginate: {
    display: 'flex',
    justifyContent: 'center',
  },
});

const bannerData = {
  imgSrc: '/images/image/message title@2x.png',
  imgSrcM: '/images/image/messagem title@2x.png',
  title: 'Brochure',
};

export default function BrochurePage() {
  const classes = useStyles();
  const list = brochureData;
  const [currentPage, setCurrentPage] = useState(1);
  const [fixedList, setFixedList] = useState([]);
  const [postsPerPage, setPostsPerPage] = useState(6);
  const [searchData, setSearchData] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  //   const indexOfLast = currentPage * postsPerPage;
  //   const indexOfFirst = indexOfLast - postsPerPage;
  //   function currentPosts(tmp) {
  //     let currentPosts = 0;
  //     currentPosts = tmp.slice(indexOfFirst, indexOfLast);
  //     return currentPosts;

  //     // 페이지네이션 slice 해주는 역할
  //   }

  useEffect(() => {
    let filtered = [];
    for (let i = 0; i < list.length; i++) {
      if (list[i].title.toUpperCase().includes(searchData.toUpperCase())) {
        filtered.push(brochureData[i]);
      }
    }
    setTotalCount(filtered.length);

    const counted = filtered.filter((l, i) => i < postsPerPage * currentPage && i >= postsPerPage * currentPage - postsPerPage);
    setFixedList(counted);
  }, [list, searchData, currentPage]);

  const handleResize = () => {
    if (window.innerWidth > 1100) {
      setPostsPerPage(6);
    } else if (window.innerWidth < 1100 && window.innerWidth > 769) {
      setPostsPerPage(4);
    } else if (window.innerWidth < 769) {
      setPostsPerPage(3);
    }

    //좌표 계산해서 컨텐츠 갯 수 조절
  };

  useEffect(() => {
    if (window.innerWidth > 1100) {
      setPostsPerPage(6);
    } else if (window.innerWidth < 1100 && window.innerWidth > 769) {
      setPostsPerPage(4);
    } else if (window.innerWidth < 769) {
      setPostsPerPage(3);
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
    //처음 화면 들어왔을 때 좌표 계산해서 갯 수 표현
  }, []);

  function newWindowBook(data) {
    window.open(`${data.pdfUrl}`, '');
  }

  function handleDownloadBtn(data) {
    const url = `${data.downUrl}`;
    const a = document.createElement('a');
    a.href = url;
    a.download = `${data.title}`;
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }

  //검색
  // const searchContents = (e) => {
  //   setSearchData(e.target.value);

  //   //검색해서 array 안에 새로 push 해주는 역할
  // };

  //
  const prevClick = () => {
    if (currentPage === 1) {
      return;
    } else setCurrentPage(currentPage - 1);
  };
  const nextClick = () => {
    if (Math.ceil(list.length / postsPerPage) === currentPage) {
      return;
    } else setCurrentPage(currentPage + 1);
  };

  const prevPageClick = () => {
    let x = Math.ceil(currentPage / 5) - 1;
    let y = x - 1;
    const z = 1;

    if (Math.ceil(currentPage / 5) === 1) {
      setCurrentPage(1);
    } else setCurrentPage(y * 5 + z);
  };

  const nextPageClick = () => {
    let x = Math.ceil(currentPage / 5) + 1;
    let y = x - 1;
    const z = 1;

    if (Math.ceil(list.length / postsPerPage / 5) === Math.ceil(currentPage / 5)) {
      return;
    } else setCurrentPage(y * 5 + z);
  };

  const handleSearch = (e) => {
    setCurrentPage(1);
    setSearchData(e.target.value);
  };

  const handleSearchIcon = () => {
    document.querySelector('#searchInput').focus();
  };
  const handleClearIcon = () => {
    setSearchData('');
    document.querySelector('#searchInput').focus();
  };

  return (
    <Box className={classes.root}>
      <Banner bannerData={bannerData} />
      <ContentBox>
        <Box className={classes.searchArea}>
          {/* <Input className={classes.input} value={searchData} onChange={searchContents}></Input>

            <SearchIcon className={classes.searchIcon}></SearchIcon> */}
          <SearchInput searchValue={searchData} handleSearch={handleSearch} handleSearchIcon={handleSearchIcon} handleClearIcon={handleClearIcon} />
        </Box>
        <Grid container className={classes.brochureBox}>
          {fixedList.map((data, i) => {
            return (
              <Grid key={i} item xs={12} sm={9} md={7} lg={6} className={classes.gridBox}>
                <Box className={classes.dataBox}>
                  <Box className={classes.dataLeft}>
                    <Box>
                      <Typography className={classes.no}>No.{data.no}</Typography>
                      <Typography className={classes.title}>{data.title}</Typography>
                      <Typography className={classes.date}>{data.date}</Typography>
                    </Box>
                    <Box className={classes.btnBox}>
                      <Button className={classes.downBtn} onClick={handleDownloadBtn.bind(this, data)}>
                        <Box className={classes.downBtnBox}>
                          <FileDownloadIcon />
                          <Typography className={classes.btnText}>Download</Typography>
                        </Box>
                      </Button>
                      <Button className={classes.viewBtn} onClick={newWindowBook.bind(this, data)}>
                        <Box className={classes.viewBtnBox}>
                          <SearchIcon />
                          <Typography className={classes.btnText}>View</Typography>
                        </Box>
                      </Button>
                    </Box>
                  </Box>
                  <Box className={classes.dataRight}>
                    <img src={data.imgSrc} alt={`brochure ${i}`} className={classes.img} />
                    <Box className={classes.imgBack}></Box>
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
        <Box className={classes.paginate}>
          <PagiNation
            prevClick={prevClick}
            prevPageClick={prevPageClick}
            nextClick={nextClick}
            currentNum={currentPage}
            nextPageClick={nextPageClick}
            postsPerPage={postsPerPage}
            totalPosts={totalCount}
            paginate={setCurrentPage}
          ></PagiNation>
        </Box>
      </ContentBox>
    </Box>
  );
}
